"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useQueuedState = require("./useQueuedState.cjs");
function useQueuedValue(initialValue, options = {}, selector) {
  const [value, setValue] = react.useState(initialValue);
  const [, addItem, queuer] = useQueuedState.useQueuedState(
    (item) => {
      setValue(item);
    },
    options,
    selector
  );
  react.useEffect(() => {
    addItem(initialValue);
  }, [initialValue, addItem]);
  return [value, queuer];
}
exports.useQueuedValue = useQueuedValue;
//# sourceMappingURL=useQueuedValue.cjs.map
